var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "k-card" }, [
    _c(
      "div",
      { staticClass: "background", style: { background: _vm.card.background } },
      [
        _vm.card.favorited
          ? _c("k-icon", {
              staticClass: "favorite",
              attrs: { icon: "favorite-filled" }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("img", { attrs: { src: _vm.card.img, alt: _vm.card.title } })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c(
          "div",
          { staticClass: "content-text" },
          [
            _c("h3", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.card.title))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "subtitle" }, [
              _vm._v("\n        " + _vm._s(_vm.subtitle) + "\n      ")
            ]),
            _vm._v(" "),
            _vm.tag
              ? _c(
                  "k-tag",
                  {
                    staticClass: "card-tag",
                    attrs: { color: _vm.tagContent.color }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.tagContent.text) + "\n      "
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("like", {
          attrs: { liked: _vm.card.liked, likes: _vm.card.likes },
          on: { click: _vm.handleLike }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb9fbd0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb9fbd0c","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/kaledo-components/src/components/KCard.vue
// module id = 2044
// module chunks = 1610